import React from 'react';
import { useTranslation } from 'react-i18next';
import { PromptBrowser } from '../../shared';

interface PromptBrowserTabProps {
  projectId?: string;
  onPromptSelect: (prompt: string) => void;
  onLoadForImage: (prompt: string) => void;
  onLoadForVideo: (prompt: string) => void;
  onClose: () => void;
}

const PromptBrowserTab: React.FC<PromptBrowserTabProps> = ({
  projectId,
  onPromptSelect,
  onLoadForImage,
  onLoadForVideo,
  onClose
}) => {
  const { t } = useTranslation('aiGenerator');

  return (
    <div>
      <div style={{ marginBottom: '20px' }}>
        <h3 style={{ margin: '0 0 15px 0', color: '#8b5cf6', fontSize: '18px' }}>
          {t('prompts.title')}
        </h3>
        <p style={{ margin: '0 0 15px 0', fontSize: '14px', color: '#ccc', lineHeight: '1.4' }}>
          {t('prompts.description')}
        </p>
      </div>

      <div style={{ 
        backgroundColor: '#1a1a1a', 
        borderRadius: '8px', 
        padding: '15px',
        border: '1px solid rgba(139, 92, 246, 0.3)',
        minHeight: '400px'
      }}>
        <PromptBrowser
          onPromptSelect={onPromptSelect}
          onLoadForImage={onLoadForImage}
          onLoadForVideo={onLoadForVideo}
          showUseActions={true}
          showSelectAction={false}
          compact={true}
          projectId={projectId}
          height="350px"
        />
      </div>

      {/* Action Buttons */}
      <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '20px' }}>
        <button
          onClick={onClose}
          style={{
            padding: '12px 24px',
            border: '1px solid rgba(255,255,255,0.2)',
            backgroundColor: 'transparent',
            color: 'white',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500'
          }}
        >
          {t('common.close')}
        </button>
      </div>
    </div>
  );
};

export default PromptBrowserTab;